import type { ChangeEvent, FC } from "react";

import { ErrorMessage } from "../ErrorMessage";

import * as styles from "./Textarea.styles";

interface Props {
  label?: string;
  name: string;
  id: string;
  value: string;
  onChange: (targetName: string, targetValue: string) => void;
  placeholder: string;
  error?: string;
  errorMessages: Record<string, string>;
}

const Textarea: FC<Props> = props => {
  const {
    label,
    name,
    id,
    value,
    onChange,
    placeholder,
    error,
    errorMessages = {},
    ...rest
  } = props;

  const handleChange = ({ target }: ChangeEvent<HTMLTextAreaElement>) => {
    onChange(target.name, target.value);
  };

  return (
    <div css={styles.textarea}>
      <label htmlFor={id}>
        {label}
        <ErrorMessage
          error={error || name}
          errorMessages={errorMessages}
          prefix={label ? " - " : ""}
        />
      </label>
      <textarea
        css={styles.textareaField}
        aria-label={label}
        onChange={handleChange}
        {...{ name, id, value, placeholder, ...rest }}
      />
    </div>
  );
};

export { Textarea };
